import { Input } from '@angular/core';
import { FormControl } from '@angular/forms';

import { validationMsgs } from '../base/util/string';
import { Field } from '../base/vo/formulario';


export interface Option {
  name: string;
  value: string;
}

export class FieldCommonComponent {
  @Input() field: Field;
  @Input() control: FormControl;
  @Input() readonly: Boolean = false;
  @Input() enableLabel = true;
  @Input() readOnly = false;

  // Funções para o HTML
  ObjectKeys = Object.keys;

  getMessageError(error: string) {
    return validationMsgs[error];
  }
}



// WEBPACK FOOTER //
// ./src/app/components/formulario/field-common.component.ts